<div class="rezept-config">
    <div class="rezept-config-section" [ngClass]="{'column-view':hasColumnView}">
        <div class="rezept-config-left">

            <div class="rezept-gelb" id="print-rezept-gelb">
                <div class="rezept-gelb-top">
                    <div class="rezept-gelb-left">
                        <div class="rezept-gelb-checkbox mt-4"></div>
                        <div class="rezept-gelb-checkbox mt-1"></div>
                        <div class="rezept-gelb-checkbox mt-1"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                    </div>
                    <div class="rezept-gelb-right">
                        <div class="table-left">
                            <span class="dot-circle">1</span>
                            <div class="rezept-gelb-watermark">{{LANGUAGE==LANGUAGE_ENUM.EN?'SAMPLE':'MUSTER'}}</div>
                            <table>
                                <tr>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td>
                                        <span></span>
                                        <span></span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <span></span>
                                        <span></span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="table-right">
                            <div class="top-box"></div>
                            <div class="another-boxes">
                                <div class="box"></div>
                                <div class="box"></div>
                                <div class="box"></div>
                                <div class="box"></div>
                            </div>
                            <table>
                                <tr>
                                    <td colspan="3">
                                        <div>
                                            <p>
                                                <span></span>
                                            </p>
                                            <p>
                                                <span></span>
                                                <span></span>
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3"></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="rezept-gelb-middle">
                    <div class="rezept-gelb-left">
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                        <div class="rezept-gelb-checkbox mt-2"></div>
                    </div>
                    <div class="rezept-gelb-right">
                        <span class="dot-circle">2</span>
                        <span class="dot-circle">3</span>
                        <div class="rezept-gelb-text">{{rezeptText}}</div>
                    </div>
                </div>
                <div class="rezept-gelb-bottom">
                    <div class="rezept-gelb-left">
                    </div>
                    <div class="rezept-gelb-right">
                        <div class="boxes">
                            <div class="boxes-left">
                                <div class="box"></div>
                                <div class="box"></div>
                            </div>
                            <div class="boxes-right"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-area">
                <div class="form-area-row">
                    <label>{{LANGUAGE==LANGUAGE_ENUM.EN?'Medical Cannabis Product':'Cannabisarzneimittel'}}:</label>
                    <input *ngIf="!showDropdown" type="text" class="form-control" [(ngModel)]="cannabisText" />
                    <ng-select *ngIf="showDropdown" [(ngModel)]="cannabisText" autocomplete="new-password" [searchable]="false" appendTo="body">
                        <ng-option *ngFor="let option of cannabisDDL" [value]="option">
                            {{option}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="form-area-row">
                    <label>{{LANGUAGE==LANGUAGE_ENUM.EN?'Prescription Information':'Rezeptangaben'}}:</label>
                    <textarea class="form-control" [(ngModel)]="rezeptangabenText" rows="5"></textarea>
                </div>
            </div>
            <div class="form-buttons">
                <div class="button-item" (click)="printRezept()">
                    <img src="/pep/images/Musterrezept Drucken.svg" alt="Musterrezept Drucken.svg" />
                    <span>{{LANGUAGE==LANGUAGE_ENUM.EN?'Print Sample Prescription':'Musterrezept Drucken'}}</span>
                </div>
                <div class="button-item" (click)="copyRezept()">
                    <img src="/pep/images/Angaben Kopieren.svg" alt="Angaben Kopieren.svg" />
                    <span>{{LANGUAGE==LANGUAGE_ENUM.EN?'Copy Information':'Angaben Kopieren'}}</span>
                </div>
            </div>

        </div>
        <div class="rezept-config-right" *ngIf="LANGUAGE==LANGUAGE_ENUM.EN">
            <h4>Information required for prescribing medical cannabis products</h4>
            <ul>
                <li><span class="dot-circle">1</span>Patient's insurance, name, date of birth, and address</li>
                <li><span class="dot-circle">2</span>Unique name of the medical cannabis product, prescribed quantity, and dosage information</li>
                <li><span class="dot-circle">3</span>Physician's information and physician's stamp</li>
            </ul>

            <h4>Example text for dosage information by application type</h4>

            <div class="fw-medium">Oral administration: e.g., Cannabis extract</div>
            <p>e.g., "MC Name: Cannabis Extract THCxx:CBDxx" with xx mg THC/mL and CBD xx mg/mL, xx ml, oral administration >>morning xx ml, evening xx ml<<</p>

            <div class="fw-medium">Oral administration: Dronabinol</div>
            <p>e.g., Dronabinol 25 mg THC/mL, xx ml, oral administration >>morning xx ml, evening xx ml<<</p>

            <div class="fw-medium">Inhalation: e.g., Cannabis flowers</div>
            <p>e.g., "MC Name: Cannabis Flower xx/x", xx g >> Vaporize and inhale xxx mg x times daily<<</p>

            <div class="fw-medium">Oral spray: Nabiximols</div>
            <p>e.g., Sativex Spray 27 mg/25 mg, 3 x 10 ml, for oromucosal use >> x - 0 - x sprays <<</p>

            <div class="fw-medium">Oral administration of capsules: e.g., cannabis capsules</div>
            <p>e.g., “MC Name: Capsules” xx mg THC and xx mg CBD, xx capsules, oral administration >>x - x - x<<</p>
        </div>

        <div class="rezept-config-right" *ngIf="LANGUAGE!=LANGUAGE_ENUM.EN">
            <h4>Erforderliche Angaben bei der Verschreibung von Cannabisarzneimitteln</h4>
            <ul>
                <li><span class="dot-circle">1</span>Versicherung, Name, Geburtsdatum und Adresse des/der Patienten:in</li>
                <li><span class="dot-circle">2</span>Eindeutige Bezeichnung des Cannabisarzneimittels, der Verordnungsmenge und Angaben zur Dosierung</li>
                <li><span class="dot-circle">3</span>Angaben des Arztes und Arztstempel</li>
            </ul>

            <h4>Beispieltexte für Dosierungsangabe per Applikationsform</h4>

            <div class="fw-medium">Orale Einnahme: z.B Cannabisextrakt</div>
            <p>z.B. “CAM Name: Cannabisextrakt THCxx:CBDxx” mit xx mg THC/mL und CBD xx mg/mL, xx ml, orale Einnahme >>morgens xx ml, abends xx ml<<</p>

            <div class="fw-medium">Orale Einnahme: Dronabinol</div>
            <p>z.B. Dronabinol 25 mg THC/mL, xx ml, orale Einnahme >>morgens xx ml, abends xx ml<<</p>

            <div class="fw-medium">Inhalative Einnahme: z.B Cannabisblüten</div>
            <p>z.B. “CAM Name: Cannabisblüte xx/x”, xx g unzerkleinert >>x mal täglich xxx mg verdampfen und inhalieren<<</p>

            <div class="fw-medium">Spray zur Anwendung in der Mundhöhle: Nabiximols</div>
            <p>z.B. Sativex Spray 27 mg/25 mg, 3 x 10 ml, zur Anwendung in der Mundhöhle >> x - 0 - x Sprühstöße <<</p>

            <div class="fw-medium">Orale Einnahme von Kapseln: z.B Cannabiskapseln</div>
            <p>z.B. “CAM Name: Kapseln” xx mg THC und xx mg CBD, xx Kapseln, orale Einnahme  >>x - x - x<<</p>
        </div>
    </div>
</div>
